import { Dispatch, SetStateAction } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import Button from 'components/new-ui/base/button/Button';
import {
    PopoverGlobalStyles,
    StyledPopover,
    StyledPopoverButton,
} from 'components/new-ui/composed/popover-buttons-group/styles';

type Props = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    disabled?: boolean;
    onCreateJob: () => void;
    onAddExistingJob: () => void;
    onAddThirdPartyJob: () => void;
};

const NewJobButtonPopover = ({ open, setOpen, onCreateJob, onAddExistingJob, onAddThirdPartyJob, disabled }: Props) => {
    return (
        <>
            <PopoverGlobalStyles />
            <StyledPopover
                trigger="click"
                overlayInnerStyle={{
                    borderRadius: 6,
                }}
                placement="bottomRight"
                showArrow={false}
                open={open}
                onOpenChange={(visible) => setOpen(visible)}
                content={
                    <>
                        <StyledPopoverButton onClick={onCreateJob}>Create New Job</StyledPopoverButton>
                        <StyledPopoverButton onClick={onAddExistingJob}>Add Existing Job</StyledPopoverButton>
                        <StyledPopoverButton onClick={onAddThirdPartyJob}>Add 3rd-party Job</StyledPopoverButton>
                    </>
                }
            >
                <Button disabled={disabled} onClick={() => setOpen(true)} icon={<PlusOutlined />} type="primary">
                    New Job
                </Button>
            </StyledPopover>
        </>
    );
};

export default NewJobButtonPopover;
